import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import {Send} from "react-feather";

class   ShowInvertFriend extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.props=props;
    }


    componentDidMount() {

    }

    render() {
         

        return (
            <>
                <div className="box shadow-sm mb-3 rounded bg-white ads-box text-center pt-4">
                    <img src="/images/invite.png" className="img-fluid" alt="Responsive image"/>
                    <div className="p-3 border-bottom">
                        <h6 className="font-weight-bold text-dark pt-2">
                            دوستانت را دعوت کن
                        </h6>
                        <p className="mb-0 text-muted">

                        </p>
                    </div>
                    <div className="p-3">
                        <form
                            className=" d-inline-block form-inline mr-auto my-2 my-md-0 mw-100 input-group-1">
                            <div className="input-group">
                                <input type="text" className="form-control shadow-none border-0"
                                       placeholder="شماره تلفن همراه"/>
                                <div className="input-group-append">
                                    <button className="btn" type="button">
                                        <Send size={16} />
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </>
        ); 
  }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

ShowInvertFriend.contextType = MCbrowser;

export default ShowInvertFriend;
